module.exports = {
  language: 'Polish',
  nationalityKay: 'pl-pl',
  personal: {
    purgePopupContent:
      'Przepraszamy, dane Twojej aplikacji zostały usunięte ze względu na politykę bezpieczeństwa, możesz skontaktować się z nami, jeśli chcesz wkrótce złożyć aplikację'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Proszę wybrać',
  multiselect: {
    deselect: 'Naciśnij Enter, aby usunąć',
    select: 'Naciśnij Enter, aby wybrać',
    selected: 'Wybrano'
  },
  enter: 'Wchodzić',
  upload_failed: 'Przesyłanie nie powiodło się, spróbuj ponownie',
  due_time: 'Termin',
  requirement: 'Wymóg',
  something_went_wrong_please_retry: 'Coś poszło nie tak, proszę spróbować ponownie.',
  valid_rediret_home_page_popup_content:
    "Wystąpił wyjątek logowania. Czy próbujesz przejść na stronę główną [ {country} - {center} ], aby się zalogować? Jeśli tak, proszę kliknąć 'Confirm'; jeśli nie, proszę kliknąć 'Cancel', aby wybrać ponownie.",
  invalid_rediret_home_page_popup_content: 'Wystąpił wyjątek logowania, proszę wybrać kraj i lokalizację, aby kontynuować.',
  'Temporarily not available': 'Chwilowo niedostępne',
  'Coming soon': 'Wkrótce'
};
